export default __webpack_public_path__ + "static/media/824.8b655f04.png";